import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/library", label: "全部视频" },
  { to: "/library?category=娱乐综艺", label: "娱乐综艺" },
  { to: "/library?category=热剧剪辑", label: "热剧剪辑" },
  { to: "/library?category=搞笑日常", label: "搞笑日常" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

const categories = ["娱乐综艺", "明星八卦", "热剧剪辑", "搞笑日常", "社会热点", "生活妙招"];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-accent-50">
      <div className="container-x grid gap-8 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-2.5" aria-label="瓜趣视频首页">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-circle-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg text-primary-700">瓜趣视频</span>
          </Link>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            专注提供秒开播放体验的娱乐资讯与热门视频聚合平台。无需安装、网页直连、高清流畅，随时随地畅享最新内容。
          </p>
        </div>

        <nav className="lg:col-span-1" aria-label="快速导航">
          <h2 className="font-heading text-base text-foreground-950">快速导航</h2>
          <ul className="mt-3 space-y-2">
            {quickLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="lg:col-span-1" aria-label="热门分类">
          <h2 className="font-heading text-base text-foreground-950">热门分类</h2>
          <ul className="mt-3 space-y-2">
            {categories.map((c) => (
              <li key={c}>
                <Link
                  to={`/library?category=${encodeURIComponent(c)}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-accent-700"
                >
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="lg:col-span-1">
          <h2 className="font-heading text-base text-foreground-950">联系我们</h2>
          <p className="mt-3 text-sm text-foreground-600">有任何建议或投稿需求，欢迎随时联系我们。</p>
          <a
            href="mailto:hi@guqu.example.com"
            className="mt-2 flex items-center gap-2 text-sm text-primary-600 hover:underline"
          >
            <i className="ri-mail-line" aria-hidden="true"></i>
            hi@guqu.example.com
          </a>
          <p className="mt-2 flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-24-hours-line" aria-hidden="true"></i>
            全天候在线
          </p>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 瓜趣视频 · 娱乐八卦资讯与热门视频在线观看</p>
          <p>高清流畅 · 极速缓冲 · 手机完美适配</p>
        </div>
      </div>
    </footer>
  );
}